import Signin2 from "./Demo/Authentication/SignIn/SignIn2";
import SignUp2 from "./Demo/Authentication/SignUp/SignUp2";
import ResetPassword from "./Demo/Authentication/ResetPassword";

const route = [
  { path: "/register", exact: true, name: "Signup 2", component: SignUp2 },
  { path: "/login", exact: true, name: "Signin 2", component: Signin2 },
  {
    path: "/reset-password",
    exact: true,
    name: "Reset Password",
    component: ResetPassword
  }
];

export default route;
